module.exports = __webpack_public_path__ + "static/media/poster.baa5eb06.png";